import { render } from "./DemoTable.vue?vue&type=template&id=f0a20c88"
import script from "./DemoTable.vue?vue&type=script&lang=js"
export * from "./DemoTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__